import { includes } from "lodash-es";

import { CA_PROVINCES, US_STATES } from "./states";

// (2021-12-16) https://en.wikipedia.org/wiki/List_of_postal_codes
export const COUNTRIES_WITHOUT_POSTAL_CODES = [
    "AE",
    "AG",
    "AO",
    "AW",
    "BF",
    "BI",
    "BJ",
    "BM",
    "BO",
    "BQ",
    "BS",
    "BW",
    "BZ",
    "CD",
    "CF",
    "CG",
    "CI",
    "CK",
    "CM",
    "CW",
    "DJ",
    "DM",
    "ER",
    "FJ",
    "GA",
    "GD",
    "GM",
    "GQ",
    "GY",
    "HK",
    "HM",
    "KI",
    "KM",
    "KP",
    "LY",
    "ML",
    "MO",
    "MR",
    "NL",
    "NR",
    "NU",
    "QA",
    "RW",
    "SB",
    "SC",
    "SL",
    "SR",
    "SS",
    "ST",
    "SX",
    "SY",
    "TD",
    "TF",
    "TG",
    "TK",
    "TL",
    "TO",
    "TV",
    "UG",
    "VU",
    "YE",
    "ZW",
];

export const isPostalCodeRequired = (countryCode: string) => {
    // TODO: Add more nuanced logic here for countries that have postal codes but don't use them
    return !includes(COUNTRIES_WITHOUT_POSTAL_CODES, countryCode);
};

export const isStateRequired = (countryCode: string) => {
    return includes(["CA", "US", "MX", "AU"], countryCode);
};

export const US_STATE_OPTIONS = US_STATES.map((s) => ({ label: s.name, value: s.abbreviation }));
export const CA_PROVINCE_OPTIONS = CA_PROVINCES.map((s) => ({ label: s.name, value: s.abbreviation }));

export const CA_POSTCODE_REGEX = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/;
export const US_ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
